<template>
  <div class="container">
    <div class="footer-container">
      <h5>Kampanya Koşulları</h5>
      <ol>
        <li>İlgili günde fiyat fırsatının olacağı ürünler sınırlı süreyle yayında olacaktır.</li>
        <li>Fiyat fırsatının yapılacağı ürünler stoklarla sınırlıdır.</li>
        <li>Hepsiburada, kampanyada değişiklik yapma hakkına sahiptir.</li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style src="./Footer.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/partials/Footer/Footer.vue